import React from "react";
import Overlay from "./Overlay.jsx";
class HeaderSupport extends React.Component {
  constructor(props){
    super(props);
    this.state = {
        show_workspace: false,
        show_user: false,
        theme: 'light',
        workspaces: [],
        workspaces_loading: false,
        workspaces_error: ""
    };

    this.select_workspace = this.select_workspace.bind(this);
    this.openUser = this.openUser.bind(this);
    this.logout = this.logout.bind(this);

  }

  componentDidMount(){
    const workspaceButton = document.getElementById('workspace-button');
    const userButton = document.getElementById('user-button');
    const themeClass = document.body.className.split(' ').filter((c) => c.includes('theme'))[0] || '';

    this.setState({
      theme: themeClass.includes('light') ? 'light' : 'dark'
    });

    if (workspaceButton) {
      workspaceButton.addEventListener('click', () => this.openWorkspace());
      workspaceButton.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.openWorkspace();
        }
      });
    }

    if (userButton) {
      userButton.addEventListener('click', () => this.openUser());
      userButton.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.openUser();
        }
      });
    }
  }

  openWorkspace(){
    this.setState({
      show_workspace: true,
      workspaces_error: ""
    });
    if (this.state.workspaces.length === 0){
        this.setState({
            workspaces_loading: true
        });
        fetch('/workspaces', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-csrf-token': this.props.auth_token
            }
        }).then((response) => {
            if (!response.ok) {
                throw new Error('Unable to load workspaces');
            }
            return response.json();
        }).then((json) => {
            this.setState({
                workspaces: json.workspaces ? json.workspaces : [],
                workspaces_loading: false
            });
        }).catch(() => {
            this.setState({
                workspaces_loading: false,
                workspaces_error: "Unable to load workspaces"
            });
        });
    }
  }

  select_workspace(index){
    fetch(`/setworkspace?id=${this.state.workspaces[index].id}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-csrf-token': this.props.auth_token
        }
    }).then((response) => {
        if (!response.ok) {
            throw new Error('Unable to switch workspace');
        }
        return response.json();
    }).then((json) => {
        window.location.reload();
    }).catch(() => {
        this.setState({
            workspaces_error: "Unable to switch workspace"
        });
    });
  }

  workspace_kind(workspace){
    return workspace.test_workspace ? 'Test' : 'Live';
  }

  is_current_workspace(workspace){
    return this.props.workspace && this.props.workspace.id === workspace.id;
  }

  openUser(){
    this.setState({
      show_user: true
    });
  }

  logout(){
    fetch('/logout', {
        method: 'DELETE',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-csrf-token': this.props.auth_token
        }
    }).then(() => {
        window.location.assign('/login');
    }).catch(() => {
        window.location.assign('/login');
    });
  }

  render_workspace_overlay(){
    return (
      <div className="psintegril-overlay-card">
        <div className="psintegril-overlay-card-header">
          <div>
            <h2 className="psintegril-h2">Workspaces for {this.props.account.name}</h2>
            <p className="psintegril-text">Choose the workspace to use for this session.</p>
          </div>
        </div>

        {this.state.workspaces_loading ? (
          <div className="psintegril-overlay-card-empty">Loading workspaces...</div>
        ) : null}

        {this.state.workspaces_error ? (
          <div className="psintegril-flash psintegril-flash-danger">
            <div className="psintegril-flash-content">
              <div className="psintegril-flash-message">{this.state.workspaces_error}</div>
            </div>
          </div>
        ) : null}

        {!this.state.workspaces_loading && !this.state.workspaces_error ? (
          <div className="psintegril-workspace-list">
            {this.state.workspaces.length === 0 ? (
              <div className="psintegril-overlay-card-empty">No workspaces available.</div>
            ) : null}
            {this.state.workspaces.map((workspace, index) => {
              const current = this.is_current_workspace(workspace);

              return (
                <button
                  className={`psintegril-workspace-option ${current ? 'psintegril-workspace-option-current' : ''}`}
                  key={workspace.id || index}
                  type="button"
                  onClick={() => this.select_workspace(index)}
                >
                  <span className={`psintegril-workspace-option-mark ${workspace.test_workspace ? 'psintegril-workspace-option-mark-test' : ''}`}>
                    {workspace.test_workspace ? 'T' : 'L'}
                  </span>
                  <span className="psintegril-workspace-option-copy">
                    <span className="psintegril-workspace-option-name">{workspace.name}</span>
                    <span className="psintegril-workspace-option-meta">
                      {this.workspace_kind(workspace)} - {workspace.status}
                    </span>
                  </span>
                  {current ? (
                    <span className="psintegril-workspace-current-badge">Current</span>
                  ) : null}
                </button>
              );
            })}
          </div>
        ) : null}

        <div className="psintegril-overlay-card-actions">
          <button
            className="psintegril-btn psintegril-btn-secondary"
            type="button"
            onClick={() => window.location.assign('/workspace/new')}
          >
            Add workspace
          </button>
        </div>
      </div>
    );
  }

  render_user_overlay(){
    const user = this.props.user || {};
    const rows = [
      ['ID', user.id],
      ['Email', user.email],
      ['Name', user.name],
      ['User type', user.user_type],
      ['Status', user.status],
      ['MFA required', user.mfa_required ? 'Yes' : 'No']
    ];

    return (
      <div className="psintegril-overlay-card">
        <div className="psintegril-overlay-card-header">
          <div>
            <h2 className="psintegril-h2">User</h2>
            <p className="psintegril-text">View and manage your user profile.</p>
          </div>
        </div>

        <dl className="psintegril-overlay-details">
          {rows.map(([label, value]) => (
            <div className="psintegril-overlay-detail-row" key={label}>
              <dt>{label}</dt>
              <dd>{value === undefined || value === null || value === '' ? '-' : value}</dd>
            </div>
          ))}
        </dl>

        <div className="psintegril-overlay-card-actions">
          <button
            className="psintegril-btn psintegril-btn-secondary"
            type="button"
            onClick={() => window.location.assign('/settings')}
          >
            Update
          </button>
          <button
            className="psintegril-btn psintegril-btn-danger"
            type="button"
            onClick={this.logout}
          >
            Logout
          </button>
        </div>
      </div>
    );
  }

  render(){
    const nextTheme = this.state.theme === 'light' ? 'dark' : 'light';

    return (
        <div className="psintegril-header-support">
            <button
              className="psintegril-theme-toggle"
              type="button"
              aria-label={`Switch to ${nextTheme} theme`}
              title={`Switch to ${nextTheme} theme`}
            onClick={() => {
                const set_to = nextTheme;
                fetch(`/settheme`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-csrf-token': this.props.auth_token
                    },
                    body: JSON.stringify({
                        set_to: set_to
                    })
                }).then( (response) => {
                    if (response.ok){
                        return response.json();
                    }
                    return {};
                }).then(json => {
                    document.body.classList.remove(set_to === 'light' ? 'psintegril-theme-dark' : 'psintegril-theme-light');
                    document.body.classList.add(set_to === 'dark' ? 'psintegril-theme-dark' : 'psintegril-theme-light');
                    this.setState({theme: set_to});
                });
            }}>
                <span className="psintegril-theme-toggle-icon" aria-hidden="true">
                  {this.state.theme === 'light' ? '☾' : '☀'}
                </span>
                <span className="psintegril-theme-toggle-text">
                  {this.state.theme === 'light' ? 'Dark' : 'Light'}
                </span>
            </button>
            {this.state.show_workspace ? 
                <Overlay on_cancel={() => this.setState({show_workspace: null})}>
                    {this.render_workspace_overlay()}
                </Overlay> : null}
            {this.state.show_user ? 
                <Overlay on_cancel={() => this.setState({show_user: null})}>
                    {this.render_user_overlay()}
                </Overlay> : null}
        </div>
    )
  }
}

export default HeaderSupport
